import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/tinybots.webp';
import screenshot_target from '../../../images/letterfunnel/wanglongli.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Wang Long Li"
      firstname="Long Li"
      companyname="Tinybots"
      competition="Somnox en Zorabots"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/wanglongli.js